import { LeafletPanelBody, LeafletPanelHeading } from "../shared/LeafletPanel";

import { observer } from "mobx-react-lite";
import { Div, Section } from "trunx";
import { useLocaleContext } from "../contexts/LocaleContext";
import { useRootStore } from "../models/Root";
import { SensorDisplayPrecip, SensorDisplayStream } from "../models/SensorDisplay";
import PrecipLegend from "./SensorsPanel/PrecipLegend";
import SelectSensorFilter from "./SensorsPanel/SelectSensorFilter";
import StreamLegend from "./SensorsPanel/StreamLegend";

const SensorsPanel = () => {
  const {
    dict: {
      panel: { sensors: dict },
    },
  } = useLocaleContext();

  const {
    sensors: { display },
    menus: { closePanel },
  } = useRootStore();

  return (
    <Div bulma="panel">
      <Div bulma="panel-heading">
        <LeafletPanelHeading title={dict.title} close={closePanel} />
      </Div>
      <LeafletPanelBody minHeight="500px">
        <Section>
          <SelectSensorFilter />
          {SensorDisplayPrecip.is(display) && (
            <PrecipLegend display={display} />
          )}
          {SensorDisplayStream.is(display) && (
            <StreamLegend display={display} />
          )}
        </Section>
      </LeafletPanelBody>
    </Div>
  );
};

export default observer(SensorsPanel);
